<template>
    <div class="Login-container">
        <div class="top">
            <img class="icon" :src="home_login_title" alt="">
        </div>

        <div class="login-box">
            <div class="input-row name">
                <input type="text" v-model="phone" placeholder="请输入账号">
            </div>
            <div class="input-row pwd">
                <input type="password" v-model="password" placeholder="请输入密码">
            </div>

            <div class="btn" @click="login">登录</div>
        </div>

    </div>
</template>

<script>
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        inject: ['app'],
        data() {
            return {
                phone: '',
                password: '',
                home_login_title:''
            }
        },
        mounted() {
            this.getTitleImg()
        },
        methods: {
            login() {
                if (!this.phone) {
                    return this.$ShowToast('请输入账号')
                }

                if (!this.password) {
                    return this.$ShowToast('请输入密码')
                }

                this.$Post('Common.doLogin', {
                    phone: this.phone,
                    password: this.password
                }).then(res => {
                    if (res.code == 200 && res.data.access_token) {
                        this.$SetStorage('ZTBTOKEN', res.data.access_token, 'local')
                        this.SaveUserInfo(res.data)
                        this.$nav('Common.Home')
                        this.$Bus.emit('index', {
                            showToast: true
                        })
                    }
                })
            },
            getTitleImg() {
                this.$Get('Common.getTitleImg').then(res => {
                    if (res.status) {
                        this.home_login_title = res.data.home_login_title || ''
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .Login-container {
        .top {
            display: flex;
            justify-content: center;
            margin-bottom: 164px;

            .icon {
                margin: 0 auto;
                display: block;
                // width: 742px;
                // height: auto;
            }
        }

        .login-box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            margin: 0 auto 164px;
            padding-top: 20px;
            width: 644px;
            height: 511px;
            border-radius: 0px 14px 0px 14px;
            background-image: url("/static/images/Login/box.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;

            // background-color: red;
            .input-row {
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 0 20px;
                margin-bottom: 37px;
                width: 415px;
                height: 62px;
                line-height: 62px;
                border: solid 1px #28e8ff;

                &::before {
                    content: " ";
                    display: inline-block;
                    margin-right: 20px;
                    width: 24px;
                    height: 28px;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                &.name {
                    &::before {
                        background-image: url("/static/images/Login/1.png");
                    }
                }

                &.pwd {
                    margin-bottom: 65px;

                    &::before {
                        background-image: url("/static/images/Login/2.png");
                    }
                }

                input {
                    flex: 1;
                    height: 62px;
                    line-height: 62px;
                    font-size: 20px;
                    color: #ffffff !important;
                    border: 0px;
                    background-color: rgba(0, 0, 0, 0) !important;
                }

                // 自动填充文字颜色
                input:-internal-autofill-previewed,
                input:-internal-autofill-selected {
                    -webkit-text-fill-color: #ffffff !important;
                    transition: 5000s ease-in-out 0s !important;
                }

                // 自动填充背景色
                input:-webkit-autofill {
                    box-shadow: 0 0 0px 1000px rgba(0, 0, 0, 0) inset !important;
                }

                input::-webkit-input-placeholder {
                    color: #ffffff;
                }

                input:-moz-placeholder {
                    color: #ffffff;
                }

                input::-moz-placeholder {
                    color: #ffffff;
                }

                input:-ms-input-placeholder {
                    color: #ffffff;
                }
            }

            .btn {
                width: 406px;
                height: 68px;
                line-height: 68px;
                font-size: 28px;
                color: #ffffff;
                font-weight: bold;
                text-align: center;
                background-image: url("/static/images/Login/3.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center;
                cursor: pointer;
            }
        }
    }
</style>
